import React, { useState } from "react";
import AuthHelper from "../../helpers/auth-helper/auth-helper";
import { Link } from "react-router-dom";

const B2CLoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError("");
    try {
      await AuthHelper.loginB2CWithGoogle();
    } catch (err) {
      setError(err?.message || "Failed to sign in with Google");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid login-bg">
      <div className="row vh-100 d-flex justify-content-center">
        <div className="col-12 align-self-center">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-4 mx-auto">
                <div className="card">
                  <div className="card-body p-0 auth-header-box">
                    <div className="text-center p-3">
                      <a href="#" className="logo logo-admin">
                        <img src="assets/images/logo_new.png" height={50} alt="logo" className="auth-logo" />
                      </a>
                      <h4 className="mt-3 mb-1 fw-semibold font-18">Sign in to Jely</h4>
                    </div>
                  </div>
                  <div className="card-body pt-0">
                    <div className="d-grid mt-3">
                      <button className="bouncy-button small" type="button" onClick={handleGoogleLogin}>
                        {loading ? "Continuing..." : "Continue with Google"} <i className="la la-google ms-1" />
                      </button>
                    </div>
                    {error && (
                      <div className="errorMessage mt-2">
                        <p className="text-danger">{error}</p>
                      </div>
                    )}
                    <div className="text-center mt-3">
                      <small>
                        {/* Organization user? <Link to="/login">Sign in here</Link> */}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2CLoginPage;

